import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import {
  CircularProgress,
  LinearProgress,
  Step,
  StepButton,
  Stepper,
} from "@mui/material";
import AlertBox from "../../component/AlertBox";
import { FaUser } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaCalendar, FaPhone } from "react-icons/fa6";
import { IoDocumentText } from "react-icons/io5";
import { BsBuilding } from "react-icons/bs";
import ButtonCompo from "../../component/ButtonCompo";
import DialogBox from "../../component/DialogBox";
import InputField from "../../component/InputField";
import { FiEdit3 } from "react-icons/fi";
import SelectField from "../../component/SelectField";
import AlertDialogBox from "../../component/AlertDialogBox";

export function ApplicantDetails({ applicantData, reqLink }) {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  async function updateNote() {
    try {
      setLoading(true);
      const data = {
        applicantId: applicantData?._id,
        note: note,
      };
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisition/job/applicant/edit`,
        method: "put",
        data: data,
        withCredentials: true,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setNote(applicantData?.note);
  }, [applicantData]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="shadow-lg bg-white rounded-lg">
        <div className="flex bg-blue-50/80 rounded-t-lg justify-between items-center p-5">
          <section>
            <h1 className="text-[25px] font-medium text-left w-full text-slate-800">
              {applicantData?.fullName}
            </h1>
            <p className="mt-1 text-slate-800">
              Applying For{" "}
              <Link
                className="font-medium text-blue-600 hover:underline"
                to={reqLink}
              >
                {applicantData?.hiringReq?.position}(
                {applicantData?.hiringReq?.role})
              </Link>
            </p>
          </section>
          <section className="flex items-center gap-3">
            <section>
              {applicantData?.finalStatus === "Hold" ? (
                <div className="bg-yellow-100 text-yellow-600 font-medium px-2 py-1 rounded-full border border-yellow-300">
                  Pending
                </div>
              ) : applicantData?.finalStatus === "Rejected" ? (
                <div className="bg-red-100 text-red-600 font-medium px-2 py-1 rounded-full border border-red-300">
                  Rejected
                </div>
              ) : (
                <div className="bg-green-100 text-green-600 font-medium px-2 py-1 rounded-full border border-green-300">
                  Selected
                </div>
              )}
            </section>
            <DialogBox
              trigger={
                <div className="bg-blue-500 text-white font-medium px-3 py-1 rounded-full flex items-center justify-center gap-1 cursor-pointer">
                  <FiEdit3 />
                  Note
                </div>
              }
              actionButton={
                <ButtonCompo onClick={updateNote}>Save</ButtonCompo>
              }
              title="Additional Note"
            >
              <InputField
                value={note}
                onChange={(eve) => setNote(eve?.target?.value)}
                label="Note"
                multiline
                rows={10}
              />
            </DialogBox>
          </section>
        </div>
        <div>
          <div className="p-5 border-b-[1px]">
            <div className="grid grid-cols-2 gap-5">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <FaUser className="text-[23px] text-gray-500" />
                </div>
                <div className="ml-3">
                  <h3 className="text-[15px] font-medium text-gray-500">
                    Full Name
                  </h3>
                  <p className="mt-1 text-[16px] text-gray-900">
                    {applicantData?.fullName}
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <MdEmail className="text-[23px] text-gray-500" />
                </div>
                <div className="ml-3">
                  <h3 className="text-[15px] font-medium text-gray-500">
                    Email
                  </h3>
                  <p className="mt-1 text-[16px] text-gray-900">
                    {applicantData?.email}
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <FaPhone className="text-[23px] text-gray-500" />
                </div>
                <div className="ml-3">
                  <h3 className="text-[15px] font-medium text-gray-500">
                    Phone
                  </h3>
                  <p className="mt-1 text-[16px] text-gray-900">
                    {applicantData?.phone}
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <FaCalendar className="text-[23px] text-gray-500" />
                </div>
                <div className="ml-3">
                  <h3 className="text-[15px] font-medium text-gray-500">
                    Uploaded On
                  </h3>
                  <p className="mt-1 text-[16px] text-gray-900">
                    {new Date(applicantData?.createdAt).toDateString("en-In")}
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <BsBuilding className="text-[23px] text-gray-500" />
                </div>
                <div className="ml-3">
                  <h3 className="text-[15px] font-medium text-gray-500">
                    Application Source
                  </h3>
                  <p className="mt-1 text-[16px] text-gray-900">
                    {applicantData?.applicationSource}
                  </p>
                </div>
              </div>
              {applicantData?.referrerId && (
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <FaUser className="text-[23px] text-gray-500" />
                  </div>
                  <div className="ml-3">
                    <h3 className="text-[15px] font-medium text-gray-500">
                      Referrer Employee ID
                    </h3>
                    <p className="mt-1 text-[16px] text-gray-900">
                      {applicantData?.referrerId}
                    </p>
                  </div>
                </div>
              )}
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <IoDocumentText className="text-[23px] text-gray-500" />
                </div>
                <div className="ml-3">
                  <h3 className="text-[15px] font-medium text-gray-500">
                    Resume
                  </h3>
                  <p className="mt-1 text-[16px] text-blue-500">
                    <Link
                      className="text-blue-500 font-medium hover:underline"
                      to={`${SERVER_URL}/api/v1/file/view/${applicantData?.resumePath}`}
                      target="_blank"
                    >
                      {applicantData?.resumePath}
                    </Link>
                  </p>
                </div>
              </div>
              {applicantData?.finalStatus === "Passed" && (
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <IoDocumentText className="text-[23px] text-gray-500" />
                  </div>
                  <div className="ml-3">
                    <h3 className="text-[15px] font-medium text-gray-500">
                      Offer Letter
                    </h3>
                    <p className="mt-1 text-[16px] text-blue-500">
                      {applicantData?.offerLetterLink !== undefined ? (
                        <Link
                          className="text-blue-500 font-medium hover:underline"
                          to={applicantData?.offerLetterLink}
                          target="_blank"
                        >
                          {applicantData?.offerLetterLink}
                        </Link>
                      ) : employeeDataForAccess?.admin?.letterGenerate ===
                        true ? (
                        <Link
                          className="text-blue-500 font-medium hover:underline"
                          to={`/admin/letter/generate/table/letter/Offer%20Letter?applicantId=${applicantData?._id}&emailId=${applicantData?.email}`}
                          target="_blank"
                        >
                          Generate Offer Letter
                        </Link>
                      ) : (
                        <p className="text-slate-800">Not Generated Yet</p>
                      )}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function SingleJobApplicant() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  // accessable to "talentAquisation" and "hiringReq"
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.talentAquisation === false &&
      employeeDataForAccess?.admin?.hiringReq === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const { applicantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [applicantData, setApplicantData] = useState(undefined);
  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [finalRoundSteps, setFinalRoundSteps] = useState([]);
  const [finalRoundActiveStep, setFinalRoundActiveStep] = useState(0);
  const [managerialRoundSteps, setManagerialRoundSteps] = useState([]);
  const [managerialRoundActiveStep, setManagerialRoundActiveStep] = useState(0);
  const [roundDesc, setRoundDesc] = useState("");
  const [reload, setReload] = useState(false);
  const [finalRoundData, setFinalRoundData] = useState(undefined);
  const [managerialRoundData, setManagerialRoundData] = useState(undefined);
  const [file, setFile] = useState(null);
  const fileRef = useRef(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [applicationSource, setApplicationSource] = useState("");
  const [referrerId, setReferrerId] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [finalRoundDeleteOpen, setFinalRoundDeleteOpen] = useState(false);

  function stepTransformArray(data) {
    let stepArr = [];
    let calcActiveStep = 0;
    const rawData = data;
    if (
      Array.isArray(rawData?.passedScreeningRounds) &&
      rawData?.passedScreeningRounds.length > 0
    ) {
      stepArr = rawData?.passedScreeningRounds.map((item) => {
        return {
          name: item?.desc,
          isCompleted: true,
        };
      });
    }
    stepArr.push({
      name: rawData?.currentScreeningRound?.desc,
      isCompleted: rawData?.currentScreeningStatus === "Hold" ? false : true,
      isRejected: rawData?.currentScreeningStatus === "Rejected" ? true : false,
    });
    stepArr.push({
      name: "Managerial Round",
      isCompleted: rawData?.managerialConfirmation === "Hold" ? false : true,
      isRejected: rawData?.managerialConfirmation === "Rejected" ? true : false,
    });
    stepArr.push({
      name: "Final Discussion",
      isCompleted: rawData?.hrConfirmation === "Hold" ? false : true,
      isRejected: rawData?.hrConfirmation === "Rejected" ? true : false,
    });
    if (rawData?.currentScreeningStatus === "Hold") {
      calcActiveStep = rawData?.currentScreeningRound?.round - 1;
    } else if (
      rawData?.currentScreeningStatus === "Passed" &&
      rawData?.managerialConfirmation === "Hold"
    ) {
      // 1 for current screening round and 1 for managerial round
      calcActiveStep = rawData?.passedScreeningRounds?.length + 1 + 1 - 1;
    } else if (
      rawData?.currentScreeningStatus === "Passed" &&
      rawData?.managerialConfirmation === "Passed" &&
      rawData?.hrConfirmation === "Hold"
    ) {
      // 1 for current screening round and 1 for managerial round and 1 for final discussion round
      calcActiveStep = rawData?.passedScreeningRounds?.length + 1 + 1 + 1 - 1;
    }
    // console.log(stepArr);
    // console.log(calcActiveStep);
    setSteps(stepArr);
    setActiveStep(calcActiveStep);
  }

  function finalRoundStepTransformArray(
    data,
    hrConfirmation,
    managerialConfirmation
  ) {
    let stepArr = [];
    let calcActiveStep = 0;
    const rawData = data;
    if (
      Array.isArray(rawData?.passedDiscussionRounds) &&
      rawData?.passedDiscussionRounds.length > 0
    ) {
      stepArr = rawData?.passedDiscussionRounds.map((item) => {
        return {
          name: item?.desc,
          isCompleted: true,
        };
      });
    }
    stepArr.push({
      name: rawData?.currentDiscussionRound?.desc,
      isCompleted: rawData?.currentDiscussionStatus === "Hold" ? false : true,
      isRejected:
        rawData?.currentDiscussionStatus === "Rejected" ? true : false,
    });
    stepArr.push({
      name: "Final Shortlisted",
      isCompleted:
        applicantData?.finalStatus === undefined ||
        applicantData?.finalStatus === "Hold"
          ? false
          : true,
      isRejected:
        hrConfirmation === "Rejected" || managerialConfirmation === "Rejected"
          ? true
          : false,
    });
    // -1 beacuse, to make it 0 based index
    if (rawData?.currentDiscussionStatus === "Hold") {
      calcActiveStep = rawData?.currentDiscussionRound?.round - 1;
    } else if (
      rawData?.currentDiscussionStatus === "Passed" &&
      hrConfirmation === "Hold"
    ) {
      // 1 for current screening round and 1 for final discussion round
      calcActiveStep = rawData?.passedDiscussionRounds?.length + 1;
    }
    console.log(applicantData);
    console.log(stepArr);
    console.log(calcActiveStep);
    setFinalRoundSteps(stepArr);
    setFinalRoundActiveStep(calcActiveStep);
  }

  function stepTransformArrayManager(data, hrConfirmation) {
    let stepArr = [];
    let calcActiveStep = 0;
    const rawData = data;
    if (
      Array.isArray(rawData?.passedInterviewRounds) &&
      rawData?.passedInterviewRounds.length > 0
    ) {
      stepArr = rawData?.passedInterviewRounds.map((item) => {
        return {
          name: item?.desc,
          isCompleted: true,
        };
      });
    }
    stepArr.push({
      name: rawData?.currentInterviewRound?.desc,
      isCompleted: rawData?.currentInterviewStatus === "Hold" ? false : true,
      isRejected: rawData?.currentInterviewStatus === "Rejected" ? true : false,
    });
    stepArr.push({
      name: "Final Discussion",
      isCompleted: hrConfirmation === "Hold" ? false : true,
      isRejected: hrConfirmation === "Rejected" ? true : false,
    });
    // -1 beacuse, to make it 0 based index
    if (rawData?.currentInterviewStatus === "Hold") {
      calcActiveStep = rawData?.currentInterviewRound?.round - 1;
    } else if (
      rawData?.currentInterviewStatus === "Passed" &&
      hrConfirmation === "Hold"
    ) {
      // 1 for current screening round and 1 for final discussion round
      calcActiveStep = rawData?.passedInterviewRounds?.length + 1;
    }
    // console.log(rawData?.passedInterviewRounds)
    // console.log(stepArr);
    // console.log(calcActiveStep);
    setManagerialRoundSteps(stepArr);
    setManagerialRoundActiveStep(calcActiveStep);
  }

  // fetch single applicant data
  async function getApplicantData() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisition/job/applicant/get/single/applicant/${applicantId}`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data);
      setApplicantData(res.data?.data || null);
      setFinalRoundData(res.data?.data?.hrRound || undefined);
      setManagerialRoundData(res.data?.data?.managerialRound || undefined);
      if (res.data?.data?.hrRound !== undefined) {
        finalRoundStepTransformArray(
          res.data?.data?.hrRound,
          res.data?.data?.hrConfirmation,
          res.data?.data?.managerialConfirmation
        );
      }
      stepTransformArray(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Hiring request fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (applicantData?.hrRound !== undefined) {
      finalRoundStepTransformArray(
        applicantData?.hrRound,
        applicantData?.hrConfirmation,
        applicantData?.managerialConfirmation
      );
    }
    if (applicantData?.managerialRound !== undefined) {
      stepTransformArrayManager(
        applicantData?.managerialRound,
        applicantData?.hrConfirmation
      );
    }
  }, [applicantData]);

  // ROUND 1: Screening & Interview Steps

  // increase round
  async function increaseRound() {
    if (roundDesc === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter round description");
      return;
    }
    const data = {
      applicantId: applicantId,
      roundDesc: roundDesc,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisation/screening/increase/round`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Round increased successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Round increase failed");
    } finally {
      setLoading(false);
    }
  }

  // send to manager
  async function sendToManager() {
    if (roundDesc === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter round description");
      return;
    }
    const data = {
      applicantId: applicantId,
      firstManagerialRoundDesc: roundDesc,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisation/screening/to/manager`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Applicant send to manager successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Applicant send to manager failed");
    } finally {
      setLoading(false);
    }
  }

  // ROUND 3: Final Discussion

  // increase round
  async function increaseDiscussionRound() {
    if (roundDesc === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter round description");
      return;
    }
    const data = {
      finalRoundDocId: finalRoundData?._id,
      roundDesc: roundDesc,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisation/final/round/increase`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Round increased successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Round increase failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch finl round
  async function getFinalRound() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisation/get/final/round/single/${applicantData?.hrRoundModel}`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(false);
      setSuccess(false);
      setMessage("Hiring request fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // change status
  async function changeStatus(status) {
    const data = {
      applicantId: applicantId,
      status: status,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisation/final/round/change/status`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Status changed successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Status change failed");
    } finally {
      setLoading(false);
    }
  }

  async function updateApplicant() {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("fullName", name);
      formData.append("phone", phone);
      formData.append("email", email);
      formData.append("note", note);
      formData.append("applicationSource", applicationSource);
      formData.append("referrerId", referrerId);
      formData.append("resume", file);
      formData.append("applicantId", applicantId);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisition/job/applicant/edit`,
        method: "put",
        data: formData,
        withCredentials: true,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Applicant updated successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Applicant updated failed");
    } finally {
      setLoading(false);
    }
  }

  async function firstRoundReject() {
    const data = {
      applicantId: applicantId,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisation/screening/reject/applicant`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Applicant rejected successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Applicant rejected failed");
    } finally {
      setLoading(false);
    }
  }

  const setUpdateData = () => {
    setName(applicantData?.fullName);
    setPhone(applicantData?.phone);
    setEmail(applicantData?.email);
    setApplicationSource(applicantData?.applicationSource);
    setReferrerId(applicantData?.referrerId);
  };

  const applicationSourceArray = [
    {
      title: "Career Page",
      value: "Career Page",
    },
    {
      title: "LinkedIn",
      value: "LinkedIn",
    },
    {
      title: "Naukri",
      value: "Naukri",
    },
    {
      title: "Employee Referrel",
      value: "Employee Referrel",
    },
  ];

  useEffect(() => {
    getApplicantData();
  }, [applicantId, reload]);

  useEffect(() => {
    if (applicantData?.hrRoundModel) {
      getFinalRound();
    }
  }, [applicantData]);

  if (applicantData === null) {
    return (
      <div className="text-center mt-5 text-slate-500 font-semibold">
        No data found
      </div>
    );
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <AlertDialogBox
        open={deleteOpen}
        setOpen={setDeleteOpen}
        closeActionButton={"Cancel"}
        actionButton={
          <ButtonCompo onClick={firstRoundReject} color={"error"}>
            Reject
          </ButtonCompo>
        }
      >
        <p>
          The applicant will be shown as rejected to every round. Are you still
          want to reject the applicant?
        </p>
      </AlertDialogBox>
      <AlertDialogBox
        open={finalRoundDeleteOpen}
        setOpen={setFinalRoundDeleteOpen}
        closeActionButton={"Cancel"}
        actionButton={
          <ButtonCompo onClick={() => changeStatus("Rejected")} color={"error"}>
            Reject
          </ButtonCompo>
        }
      >
        <p>
          The applicant has been passed all the rounds. Are you sure you want to
          reject the applicant?
        </p>
      </AlertDialogBox>
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <section className="flex justify-between items-center">
            <h1 className="text-[30px] font-medium text-left w-full">
              Applicant Details
            </h1>
            <DialogBox
              trigger={
                <section
                  onClick={setUpdateData}
                  className="flex items-center border w-[10rem] justify-center gap-2 p-2 rounded-full text-slate-800 cursor-pointer hover:bg-slate-50"
                >
                  <FiEdit3 className="text-[18px]" />
                  Edit Applicant
                </section>
              }
              actionButton={
                <ButtonCompo onClick={updateApplicant}>
                  Save Changes
                </ButtonCompo>
              }
            >
              <div className="w-full space-y-5">
                <input
                  type="file"
                  onChange={(eve) => setFile(eve.target.files[0])}
                  className="hidden"
                  ref={fileRef}
                />
                <InputField
                  value={name}
                  onChange={(eve) => setName(eve?.target?.value)}
                  label="Name"
                  required
                />
                <InputField
                  value={phone}
                  onChange={(eve) => setPhone(eve?.target?.value)}
                  label="Phone Number"
                  required
                />
                <InputField
                  value={email}
                  onChange={(eve) => setEmail(eve?.target?.value)}
                  label="Email ID"
                  required
                />
                <section
                  onClick={() => fileRef.current.click()}
                  className="bg-slate-100/10 py-5 flex justify-center px-3 border-dotted items-center w-full border border-blue-500 rounded-[5px] cursor-pointer"
                >
                  <IoDocumentText className="text-[22px] mr-2 text-blue-600" />
                  <p className="text-blue-600 text-[16px] flex flex-col justify-center items-center gap-1 font-medium">
                    Upload Resume *
                    {file !== null && (
                      <span className="text-slate-500">
                        1 document selected
                      </span>
                    )}
                  </p>
                </section>
                <SelectField
                  label={"Application Source"}
                  value={applicationSource}
                  valueArray={applicationSourceArray}
                  setValue={(eve) => setApplicationSource(eve?.target?.value)}
                />
                {applicationSource === "Employee Referrel" && (
                  <InputField
                    label="Employee ID"
                    value={referrerId}
                    required
                    onChange={(eve) => setReferrerId(eve?.target?.value)}
                  />
                )}
              </div>
            </DialogBox>
          </section>
          <div className="mt-5">
            <ApplicantDetails
              applicantData={applicantData}
              reqLink={`/admin/talent/aquisation/single/hiring/request/${applicantData?.hiringReq?._id}`}
            />
            <div className="mt-5 bg-white rounded-lg shadow-lg">
              <section className="bg-blue-50 p-5 rounded-t-lg">
                <h2 className="text-[18px] text-slate-700 font-medium">
                  <span className="bg-blue-500 px-3 py-1 rounded-full text-[16px] text-white font-medium mr-1">
                    Round 1
                  </span>{" "}
                  Screening & Interview Steps{" "}
                </h2>
              </section>
              <div className="p-10">
                <Stepper nonLinear activeStep={activeStep}>
                  {steps.map((step, index) => (
                    <Step key={index} completed={step.isCompleted}>
                      <StepButton color="inherit">
                        <p
                          className={
                            step.isRejected === true
                              ? "text-red-500 font-medium text-[15.7px]"
                              : " font-medium text-[15.7px]"
                          }
                        >
                          {step.name}
                        </p>
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
                {applicantData?.currentScreeningStatus === "Hold" && (
                  <section className="mt-[3rem] flex justify-end items-center gap-5">
                    <DialogBox
                      trigger={
                        <ButtonCompo variant={"contained"}>
                          Add Next Interview Step
                        </ButtonCompo>
                      }
                      title="Add Next Interview Step"
                      actionButton={
                        <ButtonCompo onClick={increaseRound}>
                          Save Changes
                        </ButtonCompo>
                      }
                    >
                      <div>
                        <InputField
                          label="Round Title"
                          onChange={(eve) => setRoundDesc(eve?.target?.value)}
                        />
                        <p className="text-slate-500 mt-3">
                          Please be careful in this step. You can't edit or
                          delete this step later.
                        </p>
                      </div>
                    </DialogBox>
                    <DialogBox
                      trigger={
                        <ButtonCompo variant={"contained"} color={"success"}>
                          Passed & Proceed To Managerial Round
                        </ButtonCompo>
                      }
                      title="Proceed To Managerial Round"
                      actionButton={
                        <ButtonCompo onClick={sendToManager}>
                          Save Changes
                        </ButtonCompo>
                      }
                    >
                      <div>
                        <InputField
                          label="Round Title"
                          onChange={(eve) => setRoundDesc(eve?.target?.value)}
                        />
                        <p className="text-slate-500 mt-3">
                          Please be careful in this step. You can't edit or
                          delete this step later.
                        </p>
                      </div>
                    </DialogBox>
                    <ButtonCompo
                      variant={"contained"}
                      color={"error"}
                      onClick={() => setDeleteOpen(true)}
                    >
                      Reject
                    </ButtonCompo>
                  </section>
                )}
              </div>
            </div>
            {applicantData?.currentScreeningStatus === "Passed" && (
              <div className="mt-5 bg-white rounded-lg shadow-lg">
                <section className="bg-blue-50 p-5 rounded-t-lg">
                  <h2 className="text-[18px] text-slate-700 font-medium">
                    <span className="bg-blue-500 px-3 py-1 rounded-full text-[16px] text-white font-medium mr-1">
                      Round 2
                    </span>{" "}
                    Managerial Discussion{" "}
                  </h2>
                </section>
                <div>
                  {managerialRoundData !== undefined ? (
                    <div className="p-10">
                      <Stepper nonLinear activeStep={managerialRoundActiveStep}>
                        {managerialRoundSteps.map((step, index) => (
                          <Step key={index} completed={step.isCompleted}>
                            <StepButton color="inherit">
                              <p
                                className={
                                  step.isRejected === true
                                    ? "text-red-500 font-medium text-[15.7px]"
                                    : " font-medium text-[15.7px]"
                                }
                              >
                                {step.name}
                              </p>
                            </StepButton>
                          </Step>
                        ))}
                      </Stepper>
                    </div>
                  ) : (
                    <div className="text-center text-slate-500 font-medium">
                      No data found
                    </div>
                  )}
                </div>
              </div>
            )}
            {applicantData?.managerialConfirmation === "Passed" && (
              <div className="mt-5 bg-white rounded-lg shadow-lg">
                <section className="bg-blue-50 p-5 rounded-t-lg">
                  <h2 className="text-[18px] text-slate-700 font-medium">
                    <span className="bg-blue-500 px-3 py-1 rounded-full text-[16px] text-white font-medium mr-1">
                      Round 3
                    </span>{" "}
                    Final Discussion{" "}
                  </h2>
                </section>
                <div>
                  {finalRoundData !== undefined ? (
                    <div className="p-10">
                      <Stepper nonLinear activeStep={finalRoundActiveStep}>
                        {finalRoundSteps.map((step, index) => (
                          <Step key={index} completed={step.isCompleted}>
                            <StepButton color="inherit">
                              <p
                                className={
                                  step.isRejected === true
                                    ? "text-red-500 font-medium text-[15.7px]"
                                    : " font-medium text-[15.7px]"
                                }
                              >
                                {step.name}
                              </p>
                            </StepButton>
                          </Step>
                        ))}
                      </Stepper>
                      {finalRoundData?.currentDiscussionStatus === "Hold" && (
                        <section className="mt-[3rem] flex justify-end items-center gap-5">
                          <DialogBox
                            trigger={
                              <ButtonCompo variant={"contained"}>
                                Add Next Discussion Step
                              </ButtonCompo>
                            }
                            title="Add Next Discussion Step"
                            actionButton={
                              <ButtonCompo onClick={increaseDiscussionRound}>
                                Save Changes
                              </ButtonCompo>
                            }
                          >
                            <div>
                              <InputField
                                label="Round Title"
                                onChange={(eve) =>
                                  setRoundDesc(eve?.target?.value)
                                }
                              />
                              <p className="text-slate-500 mt-3">
                                Please be careful in this step. You can't edit
                                or delete this step later.
                              </p>
                            </div>
                          </DialogBox>
                          <ButtonCompo
                            variant={"contained"}
                            color={"success"}
                            onClick={() => changeStatus("Passed")}
                          >
                            Shortlisted
                          </ButtonCompo>
                          <ButtonCompo
                            variant={"contained"}
                            color={"error"}
                            onClick={() => setFinalRoundDeleteOpen(true)}
                          >
                            Reject
                          </ButtonCompo>
                        </section>
                      )}
                    </div>
                  ) : (
                    <div className="text-center text-slate-500 font-medium">
                      No data found
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleJobApplicant;
